import { useTranslation } from "react-i18next";
import Button from "../../../components/ButtonUI";
import moment from "../../../helper/moment";
import { loadImage } from "../../../api/documents";
import Icon from "../../../components/Icon";
import { ReactComponent as AgendaIcon } from "../../../assets/icons/icon-agenda.svg";
import { ReactComponent as WomanPatient } from "../../../assets/illustrations/illustration-femme-patient.svg";
import { ReactComponent as ManPatient } from "../../../assets/illustrations/illustration-homme-patient.svg";
import { handleSpeciality } from "../../../helper/handleSpeciality";

const PatientMeetingDetail = ({
  closeModal,
  toggleMoveMeetModal,
  meetDetails,
}) => {
  const { t, i18n } = useTranslation() as any;
  return (
    <>
      <div className="p-5">
        <div className="flex mb-5">
          <h2 className="m-auto">{t("ProfilePatient.YourAppointment")}</h2>
          <div className="float-right close-modal">
            <Icon isIcon={true} name="close" onClick={closeModal} />
          </div>
        </div>

        <div className="flex items-center space-x-4 bg-gray-100 p-4 mb-2">
          <div className="h-16 w-16rounded-lg">
            {meetDetails.doctorId?.business_photo ? (
              <img
                crossOrigin="anonymous"
                referrerPolicy="origin"
                alt="profile"
                src={
                  meetDetails.doctorId?.business_photo.slice(0, 4) === "http"
                    ? meetDetails.doctorId?.business_photo
                    : loadImage(
                        meetDetails.doctorId?._id,
                        "profile",
                        "thumbnail",
                        meetDetails.doctorId?.business_photo
                      )
                }
                className="w-16 h-16 rounded-lg shadow-md object-fill"
              />
            ) : meetDetails.doctorId?.sexe === "woman" ? (
              <WomanPatient className="h-16 w-16 bg-gray-300 " />
            ) : (
              <ManPatient className="h-16 w-16 bg-gray-300 " />
            )}
          </div>
          <div className="flex flex-col">
            <span className="card-title capitalize">
              {`${meetDetails.doctorId?.firstName} ${meetDetails.doctorId?.lastName}`}
            </span>
            <span className="card-subtitle">
              {handleSpeciality(
                meetDetails.doctorId?.speciality,
                i18n.language.includes("en")
              )}
            </span>
          </div>
        </div>
        <div className="flex items-center ">
          <Icon isIcon={true} name="Motif de la consultation" />

          <p>
            <span className="card-subtitle">{t("ProfilePatient.Motif")} </span>
            <span className="ml-2">{meetDetails.motif}</span>
          </p>
        </div>
        <div className="flex items-center flex-wrap">
          <AgendaIcon className="agenda-icon" />
          <span className="card-subtitle">
            {t("ProfilePatient.DateAndTimeOfYourppointment")}
          </span>
          <span className="ml-2">
            Le {moment(meetDetails.dateConsultation).format(t("Moment.W"))}
          </span>
        </div>
        {
          meetDetails.type === "teleconsultation" && (
            <span className="card-subtitle ml-2">
              {" "}
              {t("ProfilePatient.TheConsultationConductedNyTeleconsultation")}
            </span>
          )
          // : (
          //   <div className="flex items-center ">
          //     <Icon isIcon={true} name="event-cabinet" />
          //     <span className="card-subtitle">Lieu de votre rendez-vous :</span>
          //     <span className="max-w-xs ml-2">
          //       {meetDetails.doctorId?.address}
          //     </span>
          //   </div>
          // )
        }

        <div className="flexCenter my-5 space-x-5">
          {/* <Button
            status="secondary"
            width="127px"
            height="50px"
            className="flex items-center"
          >
            <Icon isIcon={true} name="poubelle-btn" color="#4565f6" />
            supprimer
          </Button> */}
          <Button
            status="secondary"
            width="127px"
            height="50px"
            className="flex items-center"
            onClick={toggleMoveMeetModal}
          >
            <AgendaIcon className="agenda-icon-blue" />
            {t("ProfilePatient.Move")}
          </Button>
        </div>
      </div>
    </>
  );
};

export default PatientMeetingDetail;
